import React from 'react'
import "./Model_Learning.scss"
import Internship from '../components/Home/Internship/Internship'
import Domain from '../components/Home/Internship/Domain/Domain'
import { Helmet } from 'react-helmet'

const Model_Learning = () => {
  return (
    <>
<Helmet>
  <title>IT Training in Vadodara | V-Ex Tech Solution – Learn Python, MERN, and More</title>
  <meta
    name="title"
    content="IT Training in Vadodara | V-Ex Tech Solution"
  />
  <meta
    name="description"
    content="Enroll in professional IT training at V-Ex Tech Solution, Vadodara. Learn Python, MERN Stack, Data Analysis, Web Development, and more through 100% practical, hands-on sessions with expert mentors."
  />
  <meta
    name="keywords"
    content="IT training in Vadodara, coding classes Vadodara, software training Vadodara, Python course Vadodara, MERN stack training, web development training, data analysis course, V-Ex Tech Solution"
  />
  <meta name="author" content="V-Ex Tech Solution" />
</Helmet>




    <Internship />
    <Domain/>
    </>
  )
}

export default Model_Learning
